import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    meta: { title: 'UMB协同助手' }
  },
  {
    path: '/login',
    name: 'Login',
    // 路由懒加载
    component: () => import('../views/Login.vue'),
    meta: { title: '登录/注册' }
  },
  {
    path: '/task-target',
    name: 'TaskTargetSetting',
    // 路由懒加载
    component: () => import('../views/TaskTargetSetting.vue'),
    meta: { title: '任务目标设定' }
  },
  {
    path: '/strategy-setting',
    name: 'StrategySetting',
    // 路由懒加载
    component: () => import('../views/StrategySetting.vue'),
    meta: { title: '策略设定' }
  },
  {
    path: '/chat-dialog',
    name: 'ChatDialog',
    // 路由懒加载
    component: () => import('../views/ChatDialog.vue'),
    meta: { title: 'AI对话' }
  },
  {
    path: '/history-dialog',
    name: 'HistoryDialog',
    // 路由懒加载
    component: () => import('../views/HistoryDialog.vue'),
    meta: { title: '历史对话' }
  },
  {
    path: '/clone-page',
    name: 'ClonePage',
    // 路由懒加载
    component: () => import('../views/ClonePage.vue'),
    meta: { title: '无限克隆' }
  },
  {
    path: '/my-assistant',
    name: 'AssistantPage',
    // 路由懒加载
    component: () => import('../views/assistant/AssistantPage.vue'),
    meta: { title: '我的助理' }
  },
  {
    path: '/market',
    name: 'MarketPage',
    // 路由懒加载
    component: () => import('../views/market/MarketPage.vue'),
    meta: { title: '我的宙域' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局路由守卫，用于设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || 'UMB前端项目'
  next()
})

export default router 